export class SignUpPageState {
  public isSubmitting: boolean;
  public error: object | null;

  constructor() {
    this.isSubmitting = false;
    this.error = null;
  }
}
